import { Extension, textInputRule } from '@tiptap/core'
import { EM_DASH, looksLikeAddress } from './emDash'

/**
 * `--` → `—` в богатых редакторах (TipTap): у них свой ввод, глобальный
 * обработчик полей (`installEmDashTyping`) до них не достаёт. Правила ввода TipTap
 * срабатывают только на наборе и не трогают блоки кода.
 */
export const EmDash = Extension.create({
  name: 'emDash',
  addInputRules() {
    return [
      textInputRule({
        // Функция вместо /--$/: адрес в слове перед курсором замену отменяет.
        find: (text) =>
          text.endsWith('--') && !looksLikeAddress(text)
            ? { index: text.length - 2, text: '--' }
            : null,
        replace: EM_DASH,
      }),
    ]
  },
})
